import type { PlaceAttr } from "../types";

type Props = {
  attrs: PlaceAttr[];
  busy: boolean;
  onToggle: (id: string) => void;
  onSave: () => void;
};

export default function AttributesPanel({ attrs, busy, onToggle, onSave }: Props) {
  return (
    <div>
      <div className="mb-5 flex items-center justify-between gap-3">
        <div>
          <h3 className="text-lg font-semibold">Attributs</h3>
          <p className="mt-1 text-sm text-slate-500">Ce que les clients voient sur la fiche.</p>
        </div>
        <button type="button" disabled={busy} onClick={onSave} className="pr-btn">
          {busy ? "Enregistrement…" : "Enregistrer"}
        </button>
      </div>
      <ul className="grid gap-3 sm:grid-cols-2">
        {attrs.map((a) => (
          <li key={a.id}>
            <label className={`flex cursor-pointer items-center gap-3 rounded-2xl border px-4 py-3 ${a.on ? "border-violet bg-violet/5" : "border-slate-200"}`}>
              <input type="checkbox" checked={a.on} onChange={() => onToggle(a.id)} />
              <span className="text-sm">{a.label}</span>
            </label>
          </li>
        ))}
      </ul>
    </div>
  );
}
